import { createFileRoute } from '@tanstack/react-router'

import { FEATURE_LEARNPATH_VIDEO_UPLOAD } from '@/core/constants/features'
import useFeatures from '@/core/utils/features/useFeatures'
import { LearnpathsAddElementsAssetDetails } from '@/learnpaths/components/LearnpathsAddElementsAssetDetails/LearnpathsAddElementsAssetDetails'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(video)/update/video/$elementId/$assetId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  const hasLearnpathVideoUploadFeature = useFeatures(
    FEATURE_LEARNPATH_VIDEO_UPLOAD,
  )

  if (!hasLearnpathVideoUploadFeature) {
    return null
  }

  return (
    <LearnpathsAddElementsAssetDetails
      elementType="video"
      mode="update"
      {...params}
    />
  )
}
